const locale = {
	DETAILS_SOCIALNETWORKS_FIELD_TYPE: 'Tipo Social Network',
	DETAILS_SOCIALNETWORKS_FIELD_DESCRIPTION: 'Descrizione',
	DETAILS_SOCIALNETWORKS_FIELD_URL: 'URL'
};

export default locale;
